const registry = new Map();
const listeners = new Set();
function notify() {
    listeners.forEach(l => l());
}
export function registerHardcodedTabs(objectType, tabs) {
    registry.set(objectType.toLowerCase(), tabs);
    notify();
}
export function unregisterHardcodedTabs(objectType) {
    registry.delete(objectType.toLowerCase());
    notify();
}
export function getHardcodedTabs(objectType) {
    return registry.get(objectType.toLowerCase()) || [];
}
export function onHardcodedTabsChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
